
function SidebarLoadingIndicator(): JSX.Element {
  return (
    <div className="flex flex-col border rounded-sm border-b-0 bg-sideNavGray">
      <div className="w-full flex flex-col mt-4 items-start ml-[29px]">
        <div className="flex flex-inline">
        <div className="h-1 w-[73px] py-1.5 my-3 bg-dropDownBorder rounded-lg animate-pulse" />
        </div>
        
        <div className="flex flex-inline">
        <div className="h-1 w-[73px] py-1.5 my-3 bg-dropDownBorder rounded-lg animate-pulse" />
        </div>
        
        <div className="flex flex-inline">
        <div className="h-1 w-[144px] sm:w-[120px] tab:w-[100px] py-1.5 my-3 bg-dropDownBorder rounded-lg animate-pulse" />
        </div>

      </div>
      </div>
  );
}

export default SidebarLoadingIndicator;
